export const DiscountReviewResourcesEn = {
    panelTitle: "Opinions about this offer from {0}",
    remark: "Write a first review",
    remarkComment: "Write a review",
    momentText: "Published",
    viewMoreText: "Show more opinions",
};
